import lodash from 'lodash'
import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import Field, {
  useField,
} from '../../../../../../../1stlog-ui/src/components/Field'
import { useFieldPrefix } from '../../../../../../../1stlog-ui/src/components/Field/FieldContext'
import { mustBeBool } from '../../../../../../../1stlog-ui/src/components/Field/Validation'
import YesNoSelect from '../YesNoSelect'

const Wrapper = styled.div``

const LimitedQuantity = (props) => {
  const {} = props

  const { prefix } = useFieldPrefix()

  const limitedQuantityAllowed = useField('limitedQuantityAllowed')

  if (!limitedQuantityAllowed) {
    return null
  }

  return (
    <Wrapper>
      <Field
        inline
        label={i18n.t('limited_quantity', 'Begrenzte Menge')}
        name="limitedQuantityEnabled"
        validate={mustBeBool}
        validateFields={[`${prefix}.explosiveMass`]}
        required
      >
        <YesNoSelect />
      </Field>
    </Wrapper>
  )
}

export default LimitedQuantity
